export default "__VITE_PUBLIC_ASSET__f9c06ed9__"